// import FingerprintJS from "@fingerprintjs/fingerprintjs";
import ReactDOM from "react-dom/client";
import { Helmet } from "react-helmet";
import App from "./app";
import "./index.css";
import ThemeConfigProvider from "./theme_config";

import { useStore, initialState } from "store";
import axios from "axios";
import CONSTANTS from "shared/constants";
import { message } from "antd";

import strings from "resources/strings";

// //Load device fingerprint
// const fpPromise = FingerprintJS.load({ monitoring: false });

// (async () => {
//   // Get the visitor identifier when you need it.
//   const fp = await fpPromise;
//   const result = await fp.get();
//   console.log("device_id", result.visitorId);
// })();

//Device ID getter and generator
const getDeviceId = () => {
  let deviceId = useStore.getState().deviceId;
  if (!deviceId) {
    deviceId = generateUUID();
    useStore.setState({ deviceId: deviceId });
  }
  return deviceId || null;
};

function generateUUID() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  // Fallback
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

//Headers builder
const getHeaders = () => {
  return {
    "Content-Type": "application/json",
    "Device-Id": getDeviceId(),
  };
};

//Setup global Axios config
axios.defaults.baseURL = CONSTANTS.API_BASE_URL;
axios.defaults.withCredentials = true;

axios.interceptors.request.use((request) => {
  //Inject headers in all requests
  request.headers = getHeaders();

  //Log all API requests in dev
  (CONSTANTS.LOCAL || CONSTANTS.DEV) &&
    console.log(
      "AXIOS REQUEST",
      request.method,
      request.url,
      request.params,
      request.data
    );
  return request;
});

//Promise handler for single in-flight refresh request
let refreshPromise = null;

function refreshAccessToken() {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(
        "/user/refresh-access-token",
        {},
        {
          baseURL: axios.defaults.baseURL,
          withCredentials: true,
          headers: getHeaders(),
        }
      )
      .then((res) => {
        if (res.data.response.code !== 2000) {
          throw new Error("Refresh rejected");
        }
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}

axios.interceptors.response.use(
  (response) => {
    //Log all API responses in dev
    (CONSTANTS.LOCAL || CONSTANTS.DEV) &&
      console.log(
        "AXIOS RESPONSE",
        response.config.method,
        response.config.url,
        response.config.params,
        response.data
      );
    return response;
  },
  //Handle 401-Unauthorized API errors for access_token refresh flow
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await refreshAccessToken();
        return axios.request(originalRequest);
      } catch (err) {
        message.info(strings.alertUserSessionExpired, 10);
        useStore.setState(initialState); //This automatically sends us to /login
        // window.location.href = "/login";

        //Set the request error to our custom session expired error so controllers will fail silently, as we will handle the session expiration error and redirection here.
        const cancelError = new Error(
          CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED
        );
        cancelError.code = CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED;

        return Promise.reject(cancelError);
      }
    }

    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ThemeConfigProvider>
    <Helmet>
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
    </Helmet>
    <App />
  </ThemeConfigProvider>
  // </React.StrictMode>
);
